import { render, staticRenderFns } from "./PauseSnackbar.vue?vue&type=template&id=a38ecfd2&scoped=true"
import script from "./PauseSnackbar.vue?vue&type=script&lang=js"
export * from "./PauseSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38ecfd2",
  null
  
)

export default component.exports